import { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');

const validateAccess = (values = {}) => {
  const errors = {};

  if (values.targetAudience === 'targetAudience') {
    if (!values.group?.length) {
      errors.group = p('groupFieldCantBeEmpty');
    }
    if (!values.level?.length) {
      errors.level = p('levelFieldCantBeEmpty');
    }
    if (!values.tier?.length) {
      errors.tier = p('tierCantBeEmpty');
    }
  }

  return errors;
};

export default validateAccess;
